var TypeaheadOptions = (function () {
    function TypeaheadOptions(options) {
        Object.assign(this, options);
    }
    return TypeaheadOptions;
}());
export { TypeaheadOptions };
//# sourceMappingURL=typeahead-options.class.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/typeahead/typeahead-options.class.js
// module id = 1006
// module chunks = 9